import { Box, Alert, Card, Container, Grid, Typography } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import ahcStatus from '../../../../models/ahcStatus';
import Count from './count';
import AhcToolbar from './AhcToolbar';
import AhcResults from './AhcResults';
import { _axios } from 'src/plugins/axios';
import commonService from 'src/service/common';
import moment from 'moment';
import goodalipi from 'src/plugins/goodalipi';

const masterDataCountItems = JSON.parse(JSON.stringify(ahcStatus));

export class AhcEmployees extends Component {
  constructor(props) {
  console.log('in the the ahc employee')

    super(props);
    this.state = {
      totalCount: 0,
      dateRange: [],
      allEmployees: [],
      activeBookings: [],
      displayEmployees: [],
      selectionData: {
        campLocation: [],
        providerName: [],
        campType: []
      },
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: [],
        entityRequested : '',
        globalHR : goodalipi.get('globalHR') ? goodalipi.get('globalHR') : false,
      },
      filterOptions: {
        campusList: [],
        locationList: [],
        beneList: [],
        entityRequested : goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : []
      },
      loading: {
        sponseredAndPaidCount: false,
        allEmployees: false,
        activeBookings: false,
      },
      server: {
        sponseredAndPaidCount: true,
        allEmployees: true,
        activeBookings: true,
      },
      statusCount: masterDataCountItems,
      activeBookingsCount: 0,
      activeTable: 0,
      loading: false,
      showSnack: false,
      snackMsg: '',
      snackType: 'info',
      startIndex: 0,
      pageSize: 5,
      corporateType : goodalipi.get('user') ? goodalipi.get('user').corporateType : false
    }
  }


  setLoadingServer(name, loading, server) {
    this.setState((prev) => ({
      loading: {
        ...prev.loading,
        [name]: loading
      },
      server: {
        ...prev.server,
        [name]: server
      }
    }))
  }

  resetFilters() {
    this.setState({
      filter: {
        dateRange: [],
        campus: [],
        location: [],
        bene: [],
        entityRequested : goodalipi.get('globalHRgroup') ? goodalipi.get('globalHRgroup') : []
      },
    })
  }

  downloadFile(url) {
    var link = document.createElement("a");
    link.setAttribute('download', '');
    link.href = url;
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  exportFile(filetype){
    console.log(this.state.filter)
    let payload = {
      fileType: filetype
    }
    if (this.state.filter.dateRange.length == 2 && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]) {
      payload.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payload.apptDateEnd = moment(this.state.filter.dateRange[1]).format('YYYY-MM-DD')
    }
    if (this.state.filter.location.length > 0) {
      payload.location = this.state.filter.location
    }
    if (this.state.filter.campus.length > 0) {
      payload.campus = this.state.filter.campus
    }
    if(this.state.filter.entityRequested){
      payload.globalHR = true,
      payload.entityRequested = this.state.entityRequested
    }
    this.setState({ 
      loading: false,
      showSnack: true,
      snackMsg: 'File downloaded in progress...',
      snackType: 'info',
    })
    if(this.state.activeTable == 0){
      this.downloadAllEmployees(payload)
    }else if(this.state.activeTable == 1){
      this.downloadAllActiveEmployees(payload)
    } else if(this.state.activeTable == 2){
      this.downloadActiveBookings(payload)
    } else if(this.state.activeTable == 3){
      this.downloadActiveBookings(payload)
    }
  }

  downloadEligibleEmployees(payload) {
    _axios.post('ahc/eligibleList', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  downloadAllEmployees(payload) {
    _axios.post('ahc/allEmployeeList', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  downloadAllActiveEmployees(payload) {
    _axios.post('ahc/masterData', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  downloadActiveBookings(payload) {
    _axios.post('ahc/activeBookings', {
      "service": 1,
      ...payload
    },{
      ignoreLoading: true,
      headers:{
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then(response =>{
      if(response.data && response.data.isSuccess && response.data.preSignedUrl){
        this.downloadFile(response.data.preSignedUrl)
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded successfully!',
          snackType: 'success',
        })
      } else if(response.data && !response.data.isSuccess){
        this.setState({ 
          loading: false,
          showSnack: true,
          snackMsg: 'File downloaded failed!',
          snackType: 'error',
        })
      }
    }).catch((error) =>{
      this.setState({ 
        loading: false,
        showSnack: true,
        snackMsg: 'File downloaded failed!',
        snackType: 'error',
      })
    })
  }

  fetchFilters() {
    this.setLoadingServer("filter", true, true);
    _axios.post('ahc/filters', {
      "service": 1
    }, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      if (response.data && response.data.isSuccess) {
        console.log("line 294",   response.data.CityAndId);
        let city_map = [];
        _.keys(response.data.cityAndId).forEach((each) => {
          let ob = {};
          ob["key"] = each;
          ob["val"] = response.data.cityAndId[each];
          city_map.push(ob);
        })
        this.setState((prev) => ({
          filterOptions: {
            ...prev.filterOptions,
            locationList: city_map,
            campusList: (response.data.result && response.data.result.PrimaryName) ? response.data.result.PrimaryName : [],
            beneList: response.data && response.data.result && response.data.result.relation ?  response.data.result.relation : []
          },
        }))
        this.setLoadingServer("filter", false, true);
      } else {
        this.setLoadingServer("filter", false, false);
      }
    }).catch((error) => {
      this.setLoadingServer("filter", false, false);
    })
  }

  fetchSponseredAndPaidCount(obj = {}) {
    this.setLoadingServer("sponseredAndPaidCount", true, true);
    let payLoad = {};
    payLoad['service'] = 1;
    //payLoad["year"] = this.state.filter.duration
    Object.keys(obj).map((item) => {
      payLoad[item] = obj[item];
    });
    _axios.post('ahc/sponseredAndPaidCount', payLoad, {
      ignoreLoading: true,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          const data = [...this.state.statusCount]
          data.forEach(status => {
            status.totalCount = 0;
            for (let i = 0; i < response.data.result.length; i++) {
              const element = response.data.result[i];
              if (element.paid == "true" && element.R_StatusId == "Total" && status.statusName === "Total Paid") {
                status.totalCount = element.split ? element.split : 0;
              } else if (element.paid == "false" && element.R_StatusId == "Availed" && status.statusName === "Availed Sponsored") {
                status.totalCount = element.split ? element.split : 0;
              } else if (element.paid == "false" && element.R_StatusId == "Total" && status.statusName === "Total Sponsored") {
                status.totalCount = element.split ? element.split : 0;
              } else if (element.paid == "true" && element.R_StatusId == "Availed" && status.statusName === "Availed Paid") {
                status.totalCount = element.split ? element.split : 0;
              }
            }
          });
          this.setLoadingServer("sponseredAndPaidCount", false, true);
          this.setState({
            statusCount: data
          });
        } else {
          this.setLoadingServer("sponseredAndPaidCount", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("sponseredAndPaidCount", false, false);
      })
  }

  setActiveTable(tab) {
    if (tab == this.state.activeTable) {
      return;
    }
    this.setState({
      activeTable: tab,
      displayEmployees: []
    }, () => {
      if (tab === 0) {
        this.fetchAllEmployees(this.state.filter)
        this.setState({
          ...this.state,
          startIndex: 0,
          pageSize: 5
        })
      } else if (tab == 1) {
        this.fetchAllActiveEmployees(this.state.filter)
        this.setState({
          ...this.state,
          startIndex: 0,
          pageSize: 5
        })
      } else if (tab == 2) {
        this.fetchActiveBookings(this.state.filter)
        this.setState({
          ...this.state,
          startIndex: 0,
          pageSize: 5
        })
      } else if (tab == 3) {
        this.fetchActiveBookings(this.state.filter)
        this.setState({
          ...this.state,
          startIndex: 0,
          pageSize: 5
        })
      } else if (tab == 4) {
        this.fetchAhcMasterBookings(this.state.filter)
        this.setState({
          ...this.state,
          startIndex: 0,
          pageSize: 5
        })
      }
    })
  }

  fetchEligibleEmployees(obj = {}) {
    let payLoad = {}
    payLoad["service"] = 1
    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    console.log('youyoyuo',obj)
    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
      if(this.state.filter.dateRange.length > 0){
        payLoad.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
        payLoad.apptDateEnd = moment(this.state.filter.dateRange[1]).format('YYYY-MM-DD')
      }
    })
    this.setLoadingServer("eligibleList", true, true);
    _axios.post('ahc/eligibleList', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          if(response.data.result[0].totalRows){
            this.setState({
              displayEmployees: response.data.result,
              activeBookingsCount: response.data.result.length > 0 ? response.data.result[0].totalRows : 0
            }, () => this.setLoadingServer("eligibleList", false, true))
          } else {
            this.setState({
              displayEmployees: response.data.result,
            }, () => this.setLoadingServer("eligibleList", false, true))
          }
        } else {
          this.setLoadingServer("eligibleList", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("eligibleList", false, false);
      })
  }

  fetchActiveBookings(obj = {}) {

    let payLoad = {}
    payLoad["service"] = 1
    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    if (this.state.filter.dateRange.length == 2 && this.state.filter.dateRange[0] && this.state.filter.dateRange[1]) {
      payLoad.apptDateBegin = moment(this.state.filter.dateRange[0]).format('YYYY-MM-DD')
      payLoad.apptDateEnd = moment(this.state.filter.dateRange[1]).format('YYYY-MM-DD')
    }
    if (this.state.filter.location.length > 0) {
      payLoad.location = this.state.filter.location
    }
    if (this.state.filter.campus.length > 0) {
      payLoad.campus = this.state.filter.campus
    }
    if(this.state.filter.entityRequested){
      payLoad.globalHR = true,
      payLoad.entityRequested = this.state.entityRequested
    }
    this.setLoadingServer("activeBookings", true, true);
    _axios.post('ahc/activeBookings', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.result,
            activeBookingsCount: response.data.count ? response.data.count : 0
          }, () => this.setLoadingServer("activeBookings", false, true))
        } else {
          this.setLoadingServer("activeBookings", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("activeBookings", false, false);
      })
  }

  onFilterChange(type, value) {
    console.log(this.state.activeTable)
    switch (type) {
      case 'limit':
        this.state.pageSize = value;
        break;
      case 'page':
        this.state.startIndex = value;
        break;
    }
    this.setState({
       filter: {
         ...this.state.filter, globalHR : true
       }
    }, () => {
      if(this.state.activeTable == 0){
        this.fetchAllEmployees(this.state.filter);
      }
      if(this.state.activeTable == 2){
        this.fetchEligibleEmployees(this.state.filter);
      }
      if(this.state.activeTable == 3){
        this.fetchActiveBookings(this.state.filter);
      }
      if(this.state.activeTable == 4){
        this.fetchAhcMasterBookings(this.state.filter)
      }
    })
   
  }

  fetchAllActiveEmployees(obj = {}) {
    let payLoad = {}

    // payLoad["startIndex"] = this.startIndex
    // payLoad["pageSize"] = this.pageSize
    payLoad["service"] = 1

    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
      if(this.state.dateRange.length > 0){
        payLoad.apptDateBegin = moment(this.state.dateRange[0]).format('YYYY-MM-DD')
        payLoad.apptDateEnd = moment(this.state.dateRange[1]).format('YYYY-MM-DD')
      }
    })
    this.setLoadingServer("allEmployees", true, true);
    _axios.post('ahc/masterData', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.result,
            activeBookingsCount: response.data.result.length
          }, () => this.setLoadingServer("allActiveEmployees", false, true))
        } else {
          this.setLoadingServer("allActiveEmployees", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("allActiveEmployees", false, false);
      })
  }

  fetchAllEmployees(obj = {}) {
    let payLoad = {}

    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    payLoad["service"] = 1

    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
      if(this.state.dateRange.length > 0){
        payLoad.apptDateBegin = moment(this.state.dateRange[0]).format('YYYY-MM-DD')
        payLoad.apptDateEnd = moment(this.state.dateRange[1]).format('YYYY-MM-DD')
      }
    })
    this.setLoadingServer("allEmployees", true, true);
    console.log(payLoad)
    _axios.post('ahc/allEmployeeList', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.result,
            activeBookingsCount: response.data.totalCount ? response.data.totalCount : 0
          }, () => this.setLoadingServer("allEmployees", false, true))
        } else {
          this.setLoadingServer("allEmployees", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("allEmployees", false, false);
      })
  }

  fetchAhcMasterBookings(obj = {}){
    let payLoad = {}

    payLoad["startIndex"] = this.state.startIndex
    payLoad["pageSize"] = this.state.pageSize
    payLoad["service"] = 1

    Object.keys(obj).map((item) => {
      if (item !== 'dateRange') {
        payLoad[item] = obj[item]
      }
      if(this.state.dateRange.length > 0){
        payLoad.apptDateBegin = moment(this.state.dateRange[0]).format('YYYY-MM-DD')
        payLoad.apptDateEnd = moment(this.state.dateRange[1]).format('YYYY-MM-DD')
      }
    })
    this.setLoadingServer("allEmployees", true, true);
    console.log(payLoad)
    _axios.post('ahc/ahcMasterBookings', payLoad, {
      ignoreLoading: false,
      headers: {
        authtoken: commonService.getAuthToken(),
        'Content-Type': 'application/json'
      }
    })
      .then((response) => {
        if (response.data && response.data.isSuccess) {
          this.setState({
            displayEmployees: response.data.bookings,
            activeBookingsCount: response.data.count ? response.data.count : 0
          }, () => this.setLoadingServer("allEmployees", false, true))
        } else {
          this.setLoadingServer("allEmployees", false, false);
        }
      }).catch((error) => {
        this.setLoadingServer("allEmployees", false, false);
      })
  }

  applyFilters() {
    const payload = {}
    if (this.state.filter.campus.length) payload.provider = this.state.filter.campus
    if (this.state.filter.location.length) payload.cityId = this.state.filter.location
    if (this.state.filter.bene.length && this.state.activeTable == 1) payload.benf = this.state.filter.bene
    if (this.state.filter.dateRange.length == 2) {
      let startDate = new Date(this.state.filter.dateRange[0])
      let endDate = new Date(this.state.filter.dateRange[1])
      payload["apptDateBegin"] = startDate.getFullYear() + "-" + (("0" + (startDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + startDate.getDate()).slice(-2)
      payload["apptDateEnd"] = endDate.getFullYear() + "-" + (("0" + (endDate.getMonth() + 1)).slice(-2)) + "-" + ("0" + endDate.getDate()).slice(-2)
    }
    if(this.state.filter.entityRequested){
      payload.globalHR = true;
      payload.entityRequested = this.state.filter.entityRequested
    }
    
    this.fetchSponseredAndPaidCount(payload);
    if (this.state.activeTable == 0 && this.state.filter.entityRequested && !this.state.corporateType) {
      this.fetchAllEmployees(payload);
    } else if (this.state.activeTable == 1 && !this.state.corporateType) {
      this.fetchAllActiveEmployees(payload);
    } else if(this.state.activeTable == 2 && !this.state.corporateType){
        this.fetchActiveBookings(payload)
    }else if (this.state.activeTable == 3 && !this.state.corporateType) {
      this.fetchEligibleEmployees(payload);
    }else if(this.state.activeTable == 4 && !this.state.corporateType){
      this.fetchAhcMasterBookings(payload)
    }
  }

  componentDidMount() {
    this.fetchSponseredAndPaidCount();
    !this.state.corporateType && this.fetchAllEmployees();
    this.fetchFilters()
  }

  render() {
    return (
      <>
        <Helmet>
          <title>AHC | Employees</title>
        </Helmet>
        <Box
          sx={{
            backgroundColor: 'background.default',
            minHeight: '100%',
            py: 2
          }}
        >
          <Container maxWidth={false}>
            <Grid container>
              <Grid item xs={12}>
                {/* <Card sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 2,
                  px: 3,
                  pt: 2,
                  pb: 1,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}> */}
                <AhcToolbar activeTable={this.state.activeTable} filterOptions={this.state.filterOptions} filter={this.state.filter} setFilters={(value) => this.setState({ filter: value })} onRefresh={() => this.applyFilters()}></AhcToolbar>
                {/* </Card> */}
              </Grid>
              <Grid item xs={12}>
                <Card sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 2,
                  p: 3,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}>
                  <Grid item container direction="row" spacing={2}>
                    {this.state.statusCount.map((each, idx) => (<Grid
                      item
                      lg={2}
                      sm={6}
                      xl={2}
                      xs={12}
                      md={4}
                      key={idx}
                    >
                      <Count
                        status={each}
                        loading={this.state.loading.sponseredAndPaidCount}
                        server={this.state.server.sponseredAndPaidCount} />
                    </Grid>))}
                  </Grid>

                </Card>
              </Grid>
              {!this.state.corporateType && <Grid item xs={12}>
                <Card sx={{
                  width: '100%',
                  borderRadius: 4,
                  mb: 2,
                  p: 3,
                  boxShadow: '0 0 16px 0 rgba(0, 0, 0, 0.06)'
                }}>
                  <AhcResults
                    displayEmployees={this.state.displayEmployees}
                    totalCount={this.state.activeTable == 1 ? this.state.displayEmployees.length : this.state.activeBookingsCount}
                    allEmployees={this.state.allEmployees}
                    activeBookings={this.state.activeBookings}
                    setActiveTable={(e) => this.setActiveTable(e)}
                    exportFile={(filetype) => this.exportFile(filetype)}
                    activeTable={this.state.activeTable}
                    loading={this.state.loading}
                    server={this.state.server}
                    onPaginationChange={(type, value) => this.onFilterChange(type, value)} />
                </Card>
              </Grid>}
            </Grid>
          </Container>
          <Snackbar open={this.state.showSnack} anchorOrigin={{vertical: 'bottom', horizontal: 'center'}} autoHideDuration={4000} onClose={()=> this.setState({ showSnack: false})}>
            <Alert onClose={()=> this.setState({ showSnack: false})} severity={this.state.snackType}>
              {this.state.snackMsg}
            </Alert>
          </Snackbar>
        </Box>
      </>
    )
  }
}

export default AhcEmployees
